import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import axios from "axios";
import { tokens } from "../theme";

const TopSelling = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    axios
      .get("https://store.petplanet.rw/api/dashboard/top-products")
      .then((res) => {
        // DataGrid requires "id"
        const mapped = res.data.map((item: any) => ({
          id: item.product_id,
          ...item,
        }));

        setProducts(mapped);
        setLoading(false);
      });
  }, []);

  const columns = [
    {
      field: "name",
      headerName: "Product Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "total_sold",
      headerName: "Sold",
      flex: 0.5,
      renderCell: (params: any) => (
        <strong>{params.value}</strong>
      ),
    },
    {
      field: "remaining_qty",
      headerName: "Remaining",
      flex: 0.5,
      renderCell: (params: any) => (
        <span
          style={{
            fontWeight: "bold",
            color: params.value < 10 ? "#d32f2f" : "#2e7d32",
          }}
        >
          {params.value}
        </span>
      ),
    },
  ];

  return (
    <Box
      mt="20px"
      backgroundColor="#fff"
    >
      <Typography variant="h3" fontWeight="500" mb="10px">
        Top Selling Products
      </Typography>

      <Box
        height="260px"   // 👈 smaller height (dashboard style)
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: tokens.blueAccent[400],
            fontWeight: "600",

          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: tokens.grey[100],
          },
          "& .MuiCheckbox-root": {
            border: "none",
            color: `${tokens.redAccent[400]} !important`,
          },
          "& .MuiDataGrid-columnHeader.action-column--header": {
            background: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: `${tokens.grey[900]} !important`,
            fontSize: "15px",
          },
          "& .MuiDataGrid-columnSeparator--resizable": {
            color: `${tokens.blueAccent[100]} !important`,
          }
        }}>
        <DataGrid
          rows={products}
          columns={columns}
          loading={loading}
          hideFooter   // 👈 remove pagination/footer
          disableRowSelectionOnClick
        />
      </Box>
    </Box>
  );
};

export default TopSelling;